import { Breakpoints } from '@apps/gated-2021/breakpoints';
import { isInWagtailBlock } from '@lib/wagtail';
import { Colors } from '@src/colors';
import styled, { css } from 'styled-components';
import BackgroundMidnightPng from '../assets/background-midnight.png';
import BackgroundPng from '../assets/background.png';

export const Root = styled.div`
    position: relative;
    z-index: 1;
`;

export const Background = styled.div`
    position: absolute;
    z-index: 2;

    height: 100%;
    width: 100%;

    background: ${Colors.midnight};

    @media print {
        background: white;
    }
`;

// prettier-ignore
export const HomeImage = styled.div<{ displayMobile: boolean, variant: 'midnight' | 'normal' }>`
    position: absolute;
    z-index: 3;

    grid-area: image;

    top: 0;
    right: 0;
    height: 100%;
    width: 30%;

    background-color: ${Colors.midnight};
    background-image: url(${({ variant = 'midnight' }) => variant === 'midnight' ? BackgroundMidnightPng : BackgroundPng});
    background-size: cover;
    background-position: center;
    border: none;

    @media screen and (max-width: ${Breakpoints.mobile}) {
        position: unset;
        top: unset;
        right: unset;
        height: 500px;
        width: 100%;

        ${({ displayMobile }) => !displayMobile && css`
            display: none;
        `}
    }

    @media print {
        display: none;
    }
`;

export const Content = styled.div`
    grid-area: content;

    height: 100%;
    width: 100%;
`;

export const Footer = styled.div`
    grid-area: footer;
    margin: 0 auto;

    @media screen and (max-width: ${Breakpoints.mobile}) {
        display: none;
    }
`;

export const ImageWrapper = styled.div`
    @media screen and (max-width: ${Breakpoints.mobile}) {
        display: flex;
        flex-direction: column;
    }
`;

const shortViewPadding = '88px 88px 96px 88px';

const Padding = styled.div`
    padding: 88px 88px 22px 88px;

    @media print {
        padding: 70px 50px;
    }

    @media (max-height: ${Breakpoints.falseBottom}) {
        padding: ${shortViewPadding};
    }

    @media screen and (max-width: ${Breakpoints.mobile}) {
        padding: 15px 15px 65px 15px;
    }
`;

const ContentDisplay = styled(Padding)`
    display: grid;
    grid-template-areas:
        'content'
        'footer';
    grid-template-rows: auto 74px;

    @media screen and (max-width: ${Breakpoints.mobile}) {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    @media (max-height: ${Breakpoints.falseBottom}) {
        grid-template-rows: auto 0px;
        > ${Footer} {
            display: none;
        }
    }
`;

const navHeight = 64;
const calcPageHeight = `calc(100vh - ${navHeight}px)`;

export const ContentWrapper = styled(ContentDisplay)`
    position: relative;
    z-index: 4;

    grid-area: wrapper;

    min-height: ${() => (isInWagtailBlock() ? calcPageHeight : `100vh`)};

    @media screen and (max-width: ${Breakpoints.mobile}) {
        height: auto;
        min-height: unset;
    }
`;
